import React from 'react';
import { MenuItem, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

const OPTIONS = ['fr', 'en', 'ar'];

const EmailLanguagePreference = ({ value = 'fr', onChange, disabled = false }) => {
  const { t } = useTranslation();

  return (
    <TextField
      select
      fullWidth
      id="email-language"
      name="email_language"
      label={t('client_profile.email_language')}
      value={value || 'fr'}
      onChange={onChange}
      disabled={disabled}
      size="small"
    >
      {OPTIONS.map((code) => (
        <MenuItem key={code} value={code}>
          {t(`client_profile.email_language_${code}`)}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default EmailLanguagePreference;
